import { type ReactElement } from 'react'
import { NotReady, Page } from '@components'
import { useProfile, useTranslation, useWorkflowForCanvassFeature } from '@front/model'
import { LegacyAddAccountPage } from './LegacyAddAccountPage'
import { WorkflowAddAccountPage } from './WorkflowAddAccountPage'
import { createFileRoute } from '@tanstack/react-router'

function AccountAddPage(): ReactElement {
  const { t } = useTranslation()
  const { isEnabled, isLoading } = useWorkflowForCanvassFeature()
  const { user, error, hasPermission, isLoading: isProfileLoading } = useProfile()

  if (!user) return <NotReady data={user} error={error} id='user' isLoading={isProfileLoading} />
  if (isLoading) return <NotReady isLoading={isLoading} />

  if (!hasPermission('account:add')) {
    return (
      <Page>
        <Page.Heading back title={t('Add Account')} />
        <Page.Content>
          <Page.Hero icon='shield' title={t('You do not have permission to add accounts')} />
        </Page.Content>
      </Page>
    )
  }

  if (!isEnabled) return <LegacyAddAccountPage />

  return <WorkflowAddAccountPage />
}

export const Route = createFileRoute('/account_/add/')({
  component: AccountAddPage,
})
